import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { ConfirmDialog } from '../../common/views/modals/confirmDialog/ConfirmDialog';
import { editorMessages } from '../messages/editorMessages';

interface LeaveDialogProps {
  isOpen: boolean;
  isBusy: boolean;
  /** The last save failed: "Save and leave" may fail again, so the dialog says what is lost. */
  isSaveFailed: boolean;
  onSaveAndLeave: () => void;
  onStay: () => void;
}

/** A leave while the last change is not saved yet (the cover editor rule, design cover-editor e5). */
const LeaveDialogComponent: React.FC<LeaveDialogProps> = ({ isOpen, isBusy, isSaveFailed, onSaveAndLeave, onStay }) => {
  const intl = useIntl();
  return (
    <ConfirmDialog
      isOpen={isOpen}
      tone="neutral"
      title={intl.formatMessage(editorMessages.leaveTitle)}
      description={intl.formatMessage(isSaveFailed ? editorMessages.leaveTextFailed : editorMessages.leaveText)}
      confirmLabel={intl.formatMessage(editorMessages.leaveConfirm)}
      cancelLabel={intl.formatMessage(editorMessages.leaveStay)}
      isBusy={isBusy}
      onConfirm={onSaveAndLeave}
      onCancel={onStay}
    />
  );
};

export const LeaveDialog = TypedMemo(LeaveDialogComponent);
